import { fetchQuery, graphql } from 'react-relay';
import get from 'lodash.get';
import SV from 'server-vars';

import { localStorage } from 'dibs-browser-storage';
import { getBuyerId } from 'dibs-cookie-jar';

import {
    PDP_TRADE_DESIGN_MANAGER_PRO_ONBOARDING_VIEW_COUNT_STORAGE_KEY,
    PDP_TRADE_DESIGN_MANAGER_STANDARD_ONBOARDING_VIEW_COUNT_STORAGE_KEY,
} from './constants';
import {
    pdpCoachmarkMaxViewsExceeded,
    getPdpTooltipDismissed,
} from '../../pdp/PdpRespTradeOnboardingCoachmark/helpers';

import {
    DESIGN_MANAGER_PRO,
    DESIGN_MANAGER_STANDARD,
    DESIGN_MANAGER_UPGRADE_SUBMITTED,
} from 'dibs-trade-design-manager/exports/tradeDesignManagerAuthHelpers';

const query = graphql`
    query tradeDesignManagerOnboardingRulesQuery($userId: String!) {
        viewer {
            user(userId: $userId) {
                isVerifiedTrade
                tradeFirmDesignManagerProfile {
                    accountType
                }
            }
        }
    }
`;

const tradeDesignManagerOnboardingRuleFactory = ({ hasSeen, ruleVersion }) => ({
    relayEnvironment,
}) => {
    const userId = getBuyerId(document.cookie);
    const isUserTypeTrade = SV.get('settings.isUserTypeTrade') || false;
    const regularOnboardingExperienceExpired =
        pdpCoachmarkMaxViewsExceeded() || getPdpTooltipDismissed();

    if (!userId || !isUserTypeTrade || hasSeen || !regularOnboardingExperienceExpired) {
        return Promise.resolve(false);
    }

    return fetchQuery(relayEnvironment, query, {
        userId,
    }).then(res => {
        const isVerifiedTrade = get(res, 'viewer.user.isVerifiedTrade');
        const accountType = get(res, 'viewer.user.tradeFirmDesignManagerProfile.accountType');
        return isVerifiedTrade && accountType === ruleVersion;
    });
};

export function hasSeenPdpTradeDesignManagerProOnboardingModal() {
    const timesProDMModalShown =
        localStorage.getItem(PDP_TRADE_DESIGN_MANAGER_PRO_ONBOARDING_VIEW_COUNT_STORAGE_KEY) || 0;
    return timesProDMModalShown > 0;
}

export function hasSubmittedDesignManagerUpgradeRequest() {
    return localStorage.getItem(DESIGN_MANAGER_UPGRADE_SUBMITTED);
}

export function hasSeenPdpTradeDesignManagerStandardOnboardingModal() {
    //the Standard DM onboarding Modal should display two times
    //if the user has submitted a upgrade request, the modal should not pop up the second time
    const timesStandardDMModalShown =
        localStorage.getItem(PDP_TRADE_DESIGN_MANAGER_STANDARD_ONBOARDING_VIEW_COUNT_STORAGE_KEY) ||
        0;
    return timesStandardDMModalShown > 1 || hasSubmittedDesignManagerUpgradeRequest();
}

export const pdpTradeDesignManagerProOnboardingRule = tradeDesignManagerOnboardingRuleFactory({
    hasSeen: hasSeenPdpTradeDesignManagerProOnboardingModal(),
    ruleVersion: DESIGN_MANAGER_PRO,
});

export const pdpTradeDesignManagerStandardOnboardingRule = tradeDesignManagerOnboardingRuleFactory({
    hasSeen: hasSeenPdpTradeDesignManagerStandardOnboardingModal(),
    ruleVersion: DESIGN_MANAGER_STANDARD,
});
